(ns nl.mediquest.lib.effects
  (:require
   [nl.mediquest.lib.router :as router]
   [re-frame.core :as re-frame]))

(re-frame/reg-fx
 ::internal-redirect
 router/internal-redirect!)

(re-frame/reg-fx
 ::replace-token
 router/replace-token!)
